export interface DatasetKeyVariableDefinition {
    name: string;
    dbName: string;
    default: string | null;
}
